export class StyleManagerService {
  public static loadScript(scriptUrl: string): void {
    console.log("script loaded");
    const script = document.createElement('link');
    script.rel = 'stylesheet';
    script.href = scriptUrl;
    document.head.appendChild(script);
  }
}
